import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconVolumeUp } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleNkfDebugOverlay } from '../../actions';
import { isNkfDebugOverlayOpen } from '../../functions';
/**
 * Toolbar button that shows/hides the NKF-AEC debug waveform overlay — the same
 * function as the floating top-left waveform button.
 */
class NkfSpeakerButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilitySpeaker';
    icon = IconVolumeUp;
    label = 'toolbar.speaker';
    toggledLabel = 'toolbar.speakerOff';
    tooltip = 'toolbar.speaker';
    /**
     * Toggles the debug waveform overlay.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _open, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('nkf.speaker', { enable: !_open }));
        dispatch(toggleNkfDebugOverlay());
    }
    /**
     * Toggled (ON) when the overlay is visible.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._open;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _open: isNkfDebugOverlayOpen(state)
    };
}
export default translate(connect(mapStateToProps)(NkfSpeakerButton));
